// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"02cf0372","703":"5d5f51d4","787":"aadca95f"}[chunkId] + ".chunk.js";
};